import Vue from 'vue'
import * as types from '../mutation-types'
import users from '../../api/users'

var userTemplate = {
    address: "",
    email: "",
    isAdmin: false,
    name: "",
    phone: "",
    photoUrl: "",
    createdAt: "2000-01-01T00:00:00+00:00",
    updatedAt: "2018-08-12T03:53:37+00:00",
};

// state
export const state = {
    data: userTemplate
}


// getters
export const getters = {
    user: state => state.data
}

// mutations
export const mutations = {
    [types.SET_USER_DETAIL](state, data) {
        var user = data.data
        state.data = user;
    },
}

// actions
export const actions = {
    getUserDetail ({ commit }, userId) {
        users.getUserDetail(userId, (user) => {
            commit(types.SET_USER_DETAIL, {'data': user})
        })
    },

    updateUser({commit}, payload) {
        commit(types.SET_USER_DETAIL, payload)
    },

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/user.js